<template>
  <v-row class="d-flex justify-end">
    <v-col>
      <Table
        :items="items"
        :headers="allHeaders"
        :openDialog="openDialog"
        @headersUpdated="updateHeaders"
        class="mx-2"
        @refreshItems="refreshItems"
        :showRefresh="true"
        :showPagination="true"
        :itemsPerPage="20"
      />
      <v-dialog
        v-model="open"
        :max-width="maxWidth[0]"
        persistent
        @keydown.esc="reset(false)"
      >
        <Form
          :itemsSelect="dataSelects"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
          :showDate="true"
          :showCheck="true"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import Form from "@/components/Complement/Form";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import modelsLiquidation from "@/store/modelosDeLiquidacion/modelsLiquidation";
import employee from "@/models/modelosDeLiquidacion/Relations/employee";
import date from "@/store/common/date";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Table,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("modelsLiquidations.employees"),
      titleTable: "ModelosDeLiquidacion_Empleados",
      titleDelete: this.$tc("modelsLiquidations.toEmployeesLiquidation"),
      isLoading: true,
      maxWidth: ["580px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: null,
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Legajo",
          value: "file",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Desde",
          value: "dateStart",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Hasta",
          value: "dateEnd",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "150px",
        },
      ],
      order: "apellido",
    };
  },
  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    items() {
      if (
        !modelsLiquidation.state.edit.empleados ||
        modelsLiquidation.state.edit.empleados.length === 0
      ) {
        return [];
      } else {
        return modelsLiquidation.state.edit.empleados.map((item) => {
          return employee.fromJson(item);
        });
      }
    },
    employees() {
      return this.$store.state.employees.employees;
    },
    employeesSelected() {
      const editEmpleados = modelsLiquidation.state.edit.empleados;

      if (!editEmpleados || editEmpleados.length === 0) {
        return this.employees;
      }

      return this.employees.filter(
        (model) =>
          !editEmpleados.some((selected) => selected.empId === model.empId),
      );
    },
    dataSelects() {
      return [
        {
          name: "idEmployee",
          label: "Empleado",
          data: "",
          items: this.employees,
          itemsValue: "empId",
          itemsText: (item) => `${item.fullName} (${item.file})`,
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "",
          readonly: false,
        },
      ];
    },
    mode: {
      get() {
        return modelsLiquidation.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return modelsLiquidation.state.openFormRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return modelsLiquidation.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    await this.$store.dispatch("employees/getEmployees", {
      photo: false,
      order: this.order,
      soloActivos: true,
    });
    this.isLoading = false;
  },
  methods: {
    async refreshItems() {
      if (modelsLiquidation.state.edit.id) {
        await modelsLiquidation.dispatch(
          "getLiquidationModelId",
          modelsLiquidation.state.edit.id,
        );
      }
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    addEmployee(form) {
      let payload = form;
      payload.dateStart = date.state.dateFrom;
      payload.dateEnd = date.state.dateTo;
      payload.liqModeloId = modelsLiquidation.state.edit.id;
      modelsLiquidation.commit("setNew", payload);

      return new Promise((resolve, reject) => {
        modelsLiquidation
          .dispatch("addEmployee")
          .then(() => {
            this.showAlert(
              this.$tc("modelsLiquidations.addEmployeeToLiquidationSuccess"),
              "#82A1D0",
            );

            resolve();
            this.reset(false);
          })
          .catch((error) => {
            if (error.response && error.response.status === 406) {
              this.showAlert(
                this.$tc("modelsLiquidations.errorEmployee406"),
                "#ff8d58",
              );
            } else {
              this.showAlert(
                this.$tc("modelsLiquidations.errorEmployee"),
                "#ff8d58",
              );
            }
            this.reset(false);
            reject(error);
          });
      });
    },

    editEmployee(form) {
      let payload = this.detectChanges(form);
      if (Object.keys(payload).length > 0) {
        payload.fecDesdeOld = this.oldItems.dateStartInput;
        payload.liqModeloId = modelsLiquidation.state.edit.id;
        payload.id = form.idEmployee;
        payload.formItems = form;

        modelsLiquidation.commit("setEditRelation", payload);
        modelsLiquidation
          .dispatch("editEmployee")
          .then(() => {
            this.showAlert(
              this.$tc("modelsLiquidations.editEmployeeToLiquidationSuccess"),
              "#82A1D0",
            );
          })
          .catch((error) => {
            if (error.response && error.response.status === 406) {
              this.showAlert(
                this.$tc("modelsLiquidations.errorEmployee406"),
                "#ff8d58",
              );
            } else {
              this.showAlert("Ha ocurrido un error inesperado", "#ff8d58");
            }
          });
      } else {
        this.showAlert(this.$tc("validation.noEditsMessage"), "#F7DC6F");
      }

      this.reset(false);
    },

    detectChanges(newItems) {
      newItems.dateStartInput = date.state.dateFrom;
      newItems.dateEndInput = date.state.dateTo;

      const changes = {};
      const oldItem = this.oldItems;

      if (oldItem) {
        if (oldItem.dateStartInput !== newItems.dateStartInput) {
          changes.dateStartInput = newItems.dateStartInput;
        }

        if (oldItem.dateEndInput !== newItems.dateEndInput) {
          changes.dateEndInput = newItems.dateEndInput;
        }
      }

      return changes;
    },

    async openDialog(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          date.state.checkTo = true;
          modelsLiquidation.commit(
            "setModeFormRelation",
            this.$tc("modelsLiquidations.addEmployeesToLiquidation"),
          );
          this.dataSelects[0].readonly = false;
          this.dataSelects[0].items = this.employeesSelected;
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;
        case "edit":
          this.oldItems = item;
          this.dataSelects[0].items = this.employees;
          this.dataSelects[0].readonly = true;

          this.itemId = item.id;
          await this.setEdit(item);
          modelsLiquidation.commit(
            "setModeFormRelation",
            this.$tc("modelsLiquidations.editEmployeesToLiquidation"),
          );
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;
        case "delete":
          modelsLiquidation.commit("setOpenDelete", true);
          this.itemToDelete = {
            ...item,
            liqModeloId: modelsLiquidation.state.edit.id,
          };
          break;

        default:
          break;
      }
    },

    setEdit(item) {
      if (item.dateEndInput) {
        date.state.checkTo = false;
        date.state.dateTo = item.dateEndInput;
      } else {
        date.state.checkTo = true;
      }
      date.state.dateFrom = item.dateStartInput;

      this.dataSelects[0].data = item.id;
    },

    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    reset(value) {
      this.resetDate();
      modelsLiquidation.commit("setOpenFormRelation", value);
      this.dataSelects.forEach((item) => {
        item.data = "";
      });
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addEmployee(items);

          break;
        case "edit":
          this.editEmployee(items);

          break;
        default:
          break;
      }
    },

    deleteItem() {
      modelsLiquidation.commit("setItemDelete", this.itemToDelete);
      modelsLiquidation
        .dispatch("deleteEmployee")
        .then(() => {
          this.openDelete = false;
          modelsLiquidation.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("modelsLiquidations.deleteEmployeeToLiquidationSuccess"),
            "#82A1D0",
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("modelsLiquidations.errorEmployee"),
            "#ff8d58",
          );
        });
    },

    cancelDelete() {
      this.openDelete = false;
      modelsLiquidation.commit("setOpenDelete", false);
    },
  },
};
</script>
<style>
.container {
  max-width: 1500px;
}
</style>
